// Data structure for TECNAL section
// Image paths follow convention: /assets/tecnal/{category}/{filename}

export const tecnalData = {
  // Main TECNAL landing page
  tecnal: {
    slug: '/tecnal',
    breadcrumb: 'TECNAL',
    title: 'TECNAL',
    intro: [
      'TECNAL es una empresa brasileña con más de 50 años de experiencia en el desarrollo de equipos para la industria de granos y alimentos.',
      'Sus soluciones integran tecnología, eficiencia y robustez en cada etapa del proceso: recepción, secado, almacenamiento, transporte y procesamiento.'
    ],
    sections: [
      {
        heading: null,
        cards: [
          {
            title: 'Almacenamiento de granos',
            description: 'Soluciones completas para silos, transporte y secado.',
            imageKey: 'tecnal-ag-main',
            href: '/tecnal/almacenamiento-de-granos'
          },
          {
            title: 'Aceite vegetal',
            description: 'Equipos para extracción, refinado y envasado.',
            imageKey: 'tecnal-av-main',
            href: '/tecnal/aceite-vegetal'
          },
          {
            title: 'Alimento balanceado',
            description: 'Líneas de producción de alimentos balanceados y extrusados.',
            imageKey: 'tecnal-aa-main',
            href: '/tecnal/alimentacion-animal'
          },
          {
            title: 'Movimiento portuario',
            description: 'Equipos para carga, descarga y transporte de granos.',
            imageKey: 'tecnal-mp-main',
            href: '/tecnal/movimiento-portuario'
          },
          {
            title: 'Etanol de maíz',
            description: 'Tecnología para plantas de bioetanol y coproductos.',
            imageKey: 'tecnal-em-main',
            href: '/tecnal/etanol-de-maiz'
          }
        ]
      },
      {
        heading: 'Principales referencias en el mundo',
        cards: [
          {
            title: 'Equipos rotativos',
            description: 'Instalaciones en plantas industriales de Argentina, operando en procesos continuos de tratamiento y acondicionamiento de granos.',
            imageKey: 'tecnal-ref-rotativo',
            images: ['tecnal_rotativo_1.webp'],
            href: '/tecnal/referencias/equipos-rotativos'
          },
          {
            title: 'Expanders',
            description: 'Referencias en operación en complejos de crushing y producción de balanceados a nivel nacional.',
            imageKey: 'tecnal-ref-expander',
            images: ['tecnal_expander_1.webp'],
            href: '/tecnal/referencias/expanders'
          },
          {
            title: 'Enfriadoras de masa expandida',
            description: 'Equipos instalados y funcionando en líneas industriales de procesamiento y estabilización de producto.',
            imageKey: 'tecnal-ref-secadora',
            images: ['tecnal_secadora_1.webp'],
            href: '/tecnal/referencias/enfriadoras'
          }
        ]
      }
    ]
  },

  // Almacenamiento de granos page
  'almacenamiento-de-granos': {
    slug: '/tecnal/almacenamiento-de-granos',
    breadcrumb: 'Almacenamiento de granos',
    title: 'Almacenamiento de granos',
    intro: [
      'Ofrecemos equipos de última generación que combinan eficiencia, durabilidad y una excelente relación costo-beneficio.',
      'El Grupo TECNAL desarrolla soluciones para la recepción, limpieza, secado, manipulación y almacenamiento de granos, adaptadas a distintas escalas de producción, desde pequeñas explotaciones hasta grandes industrias.'
    ],
    sections: [
      {
        heading: null,
        cards: [
          {
            title: 'Prelimpieza y limpieza',
            description: 'Equipos para separar impurezas con succión regulable, autolimpieza y máxima seguridad operativa.',
            imageKey: 'tecnal-ag-prelimpieza',
            images: ['tecnal_ag_prelimpieza_3.webp', 'tecnal_ag_prelimpieza_1.webp', 'tecnal_ag_prelimpieza_2.webp', 'tecnal_ag_prelimpieza_4.webp', 'tecnal_ag_prelimpieza_5.webp'],
            href: '/tecnal/almacenamiento-de-granos/prelimpieza'
          },
          {
            title: 'Secadora vertical',
            description: 'Para semilla de soja, maíz y girasol.',
            imageKey: 'tecnal-ag-secadora-vertical',
            images: ['tecnal_ag_secadora-vertical_1.webp', 'tecnal_ag_secadora-vertical_2.webp', 'tecnal_ag_secadora-vertical_3.webp', 'tecnal_ag_secadora-vertical_4.webp'],
            href: '/tecnal/almacenamiento-de-granos/secadora-vertical'
          },
          {
            title: 'Transportador de cinta (cerrado)',
            description: 'Transportador totalmente cerrado que evita dispersión de polvo, reduce ruido y mejora la limpieza del entorno operativo.',
            imageKey: 'tecnal-ag-transportador-cinta-cerrado',
            images: ['tecnal_ag_transportador-cerrado_2.webp', 'tecnal_ag_transportador-cerrado_1.webp', 'tecnal_ag_transportador-cerrado_3.webp', 'tecnal_ag_transportador-cerrado_4.webp', 'tecnal_ag_transportador-cerrado_5.webp', 'tecnal_ag_transportador-cerrado_6.webp', 'tecnal_ag_transportador-cerrado_7.webp', 'tecnal_ag_transportador-cerrado_8.webp'],
            href: '/tecnal/almacenamiento-de-granos/transportador-cinta-cerrado'
          },
          {
            title: 'Transportador de cadena (tipo Redler)',
            description: 'Transportador robusto, silencioso y de baja fricción, ideal para grandes capacidades y operación confiable.',
            imageKey: 'tecnal-ag-transportador-cadena',
            images: ['tecnal_ag_transportador-redler_1.webp', 'tecnal_ag_transportador-redler_2.webp', 'tecnal_ag_transportador-redler_3.webp', 'tecnal_ag_transportador-redler_4.webp', 'tecnal_ag_transportador-redler_5.webp', 'tecnal_ag_transportador-redler_6.webp', 'tecnal_ag_transportador-redler_7.webp', 'tecnal_ag_transportador-redler_8.webp'],
            href: '/tecnal/almacenamiento-de-granos/transportador-cadena'
          },
          {
            title: 'Cinta transportadora',
            description: 'Cintas seguras y duraderas para el transporte continuo de granos, con estructuras reforzadas y opciones personalizadas.',
            imageKey: 'tecnal-ag-cinta-transportadora',
            images: ['tecnal_ag_cinta-transportadora_1.webp', 'tecnal_ag_cinta-transportadora_2.webp', 'tecnal_ag_cinta-transportadora_3.webp', 'tecnal_ag_cinta-transportadora_4.webp', 'tecnal_ag_cinta-transportadora_5.webp'],
            href: '/tecnal/almacenamiento-de-granos/cinta-transportadora'
          },
          {
            title: 'Transporte a rosca',
            description: 'Equipo compacto y robusto para transporte de granos en distancias cortas y medias, con mantenimiento simple.',
            imageKey: 'tecnal-ag-transporte-rosca',
            images: ['tecnal_ag_transporte-rosca_1.webp', 'tecnal_ag_transporte-rosca_2.webp', 'tecnal_ag_transporte-rosca_3.webp', 'tecnal_ag_transporte-rosca_4.webp', 'tecnal_ag_transporte-rosca_5.webp', 'tecnal_ag_transporte-rosca_6.webp'],
            href: '/tecnal/almacenamiento-de-granos/transporte-rosca'
          },
          {
            title: 'Elevador / Noria',
            description: 'Elevador vertical para granos con diseño modular, alta durabilidad y múltiples opciones de seguridad.',
            imageKey: 'tecnal-ag-elevador-noria',
            images: ['tecnal_ag_elevador_2.webp', 'tecnal_ag_elevador_1.webp', 'tecnal_ag_elevador_3.webp', 'tecnal_ag_elevador_4.webp', 'tecnal_ag_elevador_5.webp'],
            href: '/tecnal/almacenamiento-de-granos/elevador-noria'
          },
          {
            title: 'Cadenas',
            description: 'Cadenas industriales de fabricación propia, con materiales certificados y alta durabilidad para equipos de transporte.',
            imageKey: 'tecnal-ag-cadenas',
            images: ['tecnal_ag_cadenas_1.webp', 'tecnal_ag_cadenas_2.webp', 'tecnal_ag_cadenas_3.webp', 'tecnal_ag_cadenas_4.webp', 'tecnal_ag_cadenas_5.webp', 'tecnal_ag_cadenas_6.webp', 'tecnal_ag_cadenas_7.webp'],
            href: '/tecnal/almacenamiento-de-granos/cadenas'
          }
        ]
      }
    ]
  },

  // Aceite vegetal page
  'aceite-vegetal': {
    slug: '/tecnal/aceite-vegetal',
    breadcrumb: 'Aceite vegetal',
    title: 'Aceite vegetal',
    intro: [
      'El Grupo TECNAL desarrolla tecnologías de última generación para la preparación y extracción de aceites vegetales, alcanzando altos estándares de calidad, rendimiento y eficiencia operativa.',
      'Desde Meyle SRL representamos su línea de equipos, acercando soluciones que optimizan la productividad y reducen los costos de operación en plantas industriales.'
    ],
    sections: [
      {
        heading: null,
        cards: [
          {
            title: 'Quebrador',
            description: 'Molino preciso y seguro para triturar semillas oleaginosas sin contacto entre cilindros y con ajuste fino estable.',
            imageKey: 'quebrador',
            images: ['tecnal_av_quebrador_1.webp', 'tecnal_av_quebrador_2.webp', 'tecnal_av_quebrador_3.webp', 'tecnal_av_quebrador_4.webp'],
            href: '/tecnal/aceite-vegetal/quebrador'
          },
          {
            title: 'Laminador',
            description: 'Sistema de laminación de alta precisión con rodillos homogéneos, excelente disipación térmica y seguridad avanzada.',
            imageKey: 'laminador',
            images: ['tecnal_av_laminador_1.webp', 'tecnal_av_laminador_2.webp', 'tecnal_av_laminador_3.webp', 'tecnal_av_laminador_4.webp', 'tecnal_av_laminador_5.webp', 'tecnal_av_laminador_6.webp', 'tecnal_av_laminador_7.webp', 'tecnal_av_laminador_8.webp'],
            href: '/tecnal/aceite-vegetal/laminador'
          },
          {
            title: 'Expander',
            description: 'Equipo de referencia mundial para expansión de masa oleaginosa, con operación continua y alta eficiencia energética.',
            imageKey: 'expander-aceite',
            images: ['tecnal_av_expander_1.webp', 'tecnal_av_expander_2.webp', 'tecnal_av_expander_3.webp', 'tecnal_av_expander_4.webp', 'tecnal_av_expander_5.webp', 'tecnal_av_expander_6.webp'],
            href: '/tecnal/aceite-vegetal/expander'
          },
          {
            title: 'Columna de aire',
            description: 'Columna en cascada que mejora la separación de cáscaras y aumenta la pureza y calidad del producto.',
            imageKey: 'columna-aire',
            images: ['tecnal_av_columna-aire_1.webp', 'tecnal_av_columna-aire_2.webp', 'tecnal_av_columna-aire_3.webp', 'tecnal_av_columna-aire_4.webp', 'tecnal_av_columna-aire_5.webp'],
            href: '/tecnal/aceite-vegetal/columna-de-aire'
          },
          {
            title: 'Molino de martillos MAP',
            description: 'Molino de alta precisión para molienda fina, media o gruesa, con baja temperatura y cambio rápido de tamices.',
            imageKey: 'molino-map',
            images: ['tecnal_av_molino-martillo-map_1.webp', 'tecnal_av_molino-martillo-map_2.webp', 'tecnal_av_molino-martillo-map_3.webp', 'tecnal_av_molino-martillo-map_4.webp', 'tecnal_av_molino-martillo-map_5.webp', 'tecnal_av_molino-martillo-map_6.webp'],
            href: '/tecnal/aceite-vegetal/molino-map'
          },
          {
            title: 'Molino de martillos MMT',
            description: 'Molino económico y robusto para molienda versátil, con bajo ruido y mantenimiento sencillo.',
            imageKey: 'molino-mmt',
            images: ['tecnal_av_molino-martillo-mmt_1.webp', 'tecnal_av_molino-martillo-mmt_2.webp', 'tecnal_av_molino-martillo-mmt_3.webp', 'tecnal_av_molino-martillo-mmt_4.webp', 'tecnal_av_molino-martillo-mmt_5.webp', 'tecnal_av_molino-martillo-mmt_6.webp', 'tecnal_av_molino-martillo-mmt_7.webp'],
            href: '/tecnal/aceite-vegetal/molino-mmt'
          },
          {
            title: 'Acondicionador rotativo',
            description: 'Equipo térmico para preacondicionar semillas, con calentamiento uniforme y bajo consumo de vapor.',
            imageKey: 'acondicionador-rotativo',
            images: ['tecnal_av_rotativo_1.webp', 'tecnal_av_rotativo_2.webp', 'tecnal_av_rotativo_3.webp', 'tecnal_av_rotativo_4.webp', 'tecnal_av_rotativo_5.webp'],
            href: '/tecnal/aceite-vegetal/acondicionador-rotativo'
          },
          {
            title: 'Extractor rotativo',
            description: 'Extractor de aceite de alta eficiencia, con celdas rotativas, control automático y bajo consumo energético.',
            imageKey: 'extractor-rotativo',
            images: ['tecnal_av_extractor-rotativo_1.webp', 'tecnal_av_extractor-rotativo_2.webp', 'tecnal_av_extractor-rotativo_3.webp', 'tecnal_av_extractor-rotativo_4.webp', 'tecnal_av_extractor-rotativo_5.webp'],
            href: '/tecnal/aceite-vegetal/extractor-rotativo'
          },
          {
            title: 'Recuperación de finos',
            description: 'Criba rotativa cerrada que recupera partículas finas y reduce pérdidas, mejorando el rendimiento global.',
            imageKey: 'recuperacion-finos',
            images: ['tecnal_av_recuperacion-finos_1.webp', 'tecnal_av_recuperacion-finos_2.webp', 'tecnal_av_recuperacion-finos_3.webp', 'tecnal_av_recuperacion-finos_4.webp', 'tecnal_av_recuperacion-finos_5.webp'],
            href: '/tecnal/aceite-vegetal/recuperacion-finos'
          },
          {
            title: 'Desolventizador y tostador',
            description: 'Equipo diseñado para eliminar solventes y tratar térmicamente el salvado con alto control automático y eficiencia.',
            imageKey: 'desolventizador',
            images: ['tecnal_av_tostador_1.webp', 'tecnal_av_tostador_2.webp', 'tecnal_av_tostador_3.webp', 'tecnal_av_tostador_4.webp', 'tecnal_av_tostador_5.webp', 'tecnal_av_tostador_6.webp', 'tecnal_av_tostador_7.webp', 'tecnal_av_tostador_8.webp'],
            href: '/tecnal/aceite-vegetal/desolventizador-tostador'
          },
          {
            title: 'Molino de bellota',
            description: 'Molino robusto que elimina bellotas del salvado, optimizando su calidad para secado y enfriamiento.',
            imageKey: 'molino-bellota',
            images: ['tecnal_av_molino-bellota_1.webp'],
            href: '/tecnal/aceite-vegetal/molino-bellota'
          },
          {
            title: 'Destilería',
            description: 'Sistema de destilación al vacío que reduce consumo energético y recupera solventes con máxima eficiencia.',
            imageKey: 'destileria',
            images: ['tecnal_av_destileria_1.webp', 'tecnal_av_destileria_2.webp', 'tecnal_av_destileria_3.webp', 'tecnal_av_destileria_4.webp', 'tecnal_av_destileria_5.webp', 'tecnal_av_destileria_6.webp', 'tecnal_av_destileria_7.webp', 'tecnal_av_destileria_8.webp'],
            href: '/tecnal/aceite-vegetal/destileria'
          },
          {
            title: 'Secadora / Enfriadora',
            description: 'Equipo automatizado para secado y enfriamiento homogéneo de masa expandida o salvado, con alta eficiencia térmica.',
            imageKey: 'secadora-enfriadora',
            images: ['tecnal_av_secadora-enfriador_1.webp', 'tecnal_av_secadora-enfriador_2.webp', 'tecnal_av_secadora-enfriador_3.webp', 'tecnal_av_secadora-enfriador_4.webp', 'tecnal_av_secadora-enfriador_5.webp', 'tecnal_av_secadora-enfriador_6.webp'],
            href: '/tecnal/aceite-vegetal/secadora-enfriadora'
          },
          {
            title: 'Secadora / Acondicionador',
            description: 'Equipo vertical que acondiciona y seca semillas enteras, mejorando su rotura, separación y rendimiento de extracción.',
            imageKey: 'secadora-acondicionador',
            images: ['tecnal_av_secadora-acondicionador_1.webp', 'tecnal_av_secadora-acondicionador_2.webp', 'tecnal_av_secadora-acondicionador_3.webp', 'tecnal_av_secadora-acondicionador_4.webp', 'tecnal_av_secadora-acondicionador_5.webp', 'tecnal_av_secadora-acondicionador_6.webp'],
            href: '/tecnal/aceite-vegetal/secadora-acondicionador'
          }
        ]
      }
    ]
  },

  // Alimento balanceado page
  'alimentacion-animal': {
    slug: '/tecnal/alimentacion-animal',
    breadcrumb: 'Alimento balanceado',
    title: 'Alimento balanceado',
    intro: [
      'El Grupo TECNAL desarrolla equipos de última generación para la producción de alimentos balanceados y para mascotas, integrando tecnología, eficiencia y calidad en cada etapa del proceso.',
      'Desde Meyle SRL representamos su línea de soluciones para el sector de alimento balanceado, con equipos como secadores horizontales, extrusoras EXP y EAP, y mezcladoras-recubridoras TMP, diseñados para optimizar el rendimiento y la calidad del producto final.'
    ],
    sections: [
      {
        heading: null,
        cards: [
          {
            title: 'Extrusora EDR',
            description: 'Equipo de extrusión de alta eficiencia para la cocción y desactivación de harinas y subproductos oleaginosos.',
            imageKey: 'extrusora-edr',
            images: ['tecnal_aa_extrusora-edr_2.webp', 'tecnal_aa_extrusora-edr_1.webp', 'tecnal_aa_extrusora-edr_3.webp', 'tecnal_aa_extrusora-edr_4.webp', 'tecnal_aa_extrusora-edr_5.webp', 'tecnal_aa_extrusora-edr_6.webp'],
            href: '/tecnal/alimentacion-animal/extrusora-edr'
          },
          {
            title: 'Extrusora EAP',
            description: 'Modelo robusto para la preparación y expansión de granos oleaginosos, ideal para líneas de extracción de aceite.',
            imageKey: 'extrusora-eap',
            images: ['tecnal_aa_extrusora-eap_1.webp', 'tecnal_aa_extrusora-eap_2.webp', 'tecnal_aa_extrusora-eap_3.webp'],
            href: '/tecnal/alimentacion-animal/extrusora-eap'
          },
          {
            title: 'Mezclador MDP',
            description: 'Equipo horizontal de paletas para mezcla homogénea de ingredientes secos o húmedos en procesos industriales.',
            imageKey: 'mezclador-mdp',
            images: ['tecnal_aa_mezclador-mdp_2.webp', 'tecnal_aa_mezclador-mdp_1.webp', 'tecnal_aa_mezclador-mdp_3.webp', 'tecnal_aa_mezclador-mdp_4.webp', 'tecnal_aa_mezclador-mdp_5.webp'],
            href: '/tecnal/alimentacion-animal/mezclador-mdp'
          },
          {
            title: 'Molino de martillos MAP',
            description: 'Modelo diseñado para molienda continua de productos granulados, garantizando tamaño uniforme y alta durabilidad.',
            imageKey: 'molino-map-animal',
            images: ['tecnal_aa_molino-martillo-map_3.webp', 'tecnal_aa_molino-martillo-map_1.webp', 'tecnal_aa_molino-martillo-map_2.webp', 'tecnal_aa_molino-martillo-map_4.webp', 'tecnal_aa_molino-martillo-map_5.webp', 'tecnal_aa_molino-martillo-map_6.webp'],
            href: '/tecnal/alimentacion-animal/molino-map'
          },
          {
            title: 'Molino de martillos MMT',
            description: 'Versión reforzada para molienda intensiva con fácil mantenimiento y eficiencia energética optimizada.',
            imageKey: 'molino-mmt-animal',
            images: ['tecnal_aa_molino-martillo-mmt_4.webp', 'tecnal_aa_molino-martillo-mmt_1.webp', 'tecnal_aa_molino-martillo-mmt_2.webp', 'tecnal_aa_molino-martillo-mmt_3.webp', 'tecnal_aa_molino-martillo-mmt_5.webp', 'tecnal_aa_molino-martillo-mmt_6.webp', 'tecnal_aa_molino-martillo-mmt_7.webp'],
            href: '/tecnal/alimentacion-animal/molino-mmt'
          },
          {
            title: 'Mezclador horizontal',
            description: 'Sistema con eje doble o simple para mezcla uniforme de polvos, harinas o premezclas, con tiempos de ciclo reducidos.',
            imageKey: 'mezclador-horizontal',
            images: ['tecnal_aa_mezclador-horizontal_1.webp', 'tecnal_aa_mezclador-horizontal_2.webp'],
            href: '/tecnal/alimentacion-animal/mezclador-horizontal'
          },
          {
            title: 'Secadora horizontal',
            description: 'Equipo para reducción de humedad mediante flujo de aire caliente controlado, garantizando uniformidad de secado.',
            imageKey: 'secadora-horizontal',
            images: ['tecnal_aa_secadora-horizontal_1.webp', 'tecnal_aa_secadora-horizontal_2.webp'],
            href: '/tecnal/alimentacion-animal/secadora-horizontal'
          },
          {
            title: 'Expander',
            description: 'Equipos de alta capacidad para preparación y expansión de oleaginosas, mejorando la eficiencia de extracción y el valor proteico del producto.',
            imageKey: 'expander-animal',
            images: ['tecnal_aa_expander_1.webp'],
            href: '/tecnal/alimentacion-animal/expander'
          },
          {
            title: 'Enfriador vertical',
            description: 'Diseño contracorriente para enfriamiento gradual de producto granulado o extruido, asegurando estabilidad térmica y calidad final.',
            imageKey: 'enfriador-vertical',
            images: ['tecnal_aa_enfriador-vertical_1.webp', 'tecnal_aa_enfriador-vertical_2.webp', 'tecnal_aa_enfriador-vertical_3.webp'],
            href: '/tecnal/alimentacion-animal/enfriador-vertical'
          },
          {
            title: 'Acondicionador horizontal',
            description: 'Unidad para control de humedad y temperatura antes de la extrusión o prensado, asegurando condiciones óptimas de proceso.',
            imageKey: 'acondicionador-horizontal',
            images: ['tecnal_aa_acondicionador-horizontal_1.webp'],
            href: '/tecnal/alimentacion-animal/acondicionador-horizontal'
          },
          {
            title: 'Premezcladora',
            description: 'Sistema diseñado para mezclar líquidos y sólidos en proporciones exactas antes de la extrusión o peletizado.',
            imageKey: 'premezcladora',
            images: ['tecnal_aa_premezcladora_1.webp'],
            href: '/tecnal/alimentacion-animal/premezcladora'
          },
          {
            title: 'Extrusora EXA',
            description: 'Equipo de extrusión de gran porte para procesamiento continuo, con control preciso de temperatura y presión.',
            imageKey: 'extrusora-exa',
            images: ['tecnal_aa_extrusora-exa_1.webp'],
            href: '/tecnal/alimentacion-animal/extrusora-exa'
          },
          {
            title: 'Recubridor continuo',
            description: 'Equipo para aplicación uniforme de aceites, grasas o aditivos sobre el producto final, con control de caudal y temperatura.',
            imageKey: 'recubridor-continuo',
            images: ['tecnal_aa_recubridor-continuo_1.webp'],
            href: '/tecnal/alimentacion-animal/recubridor-continuo'
          },
          {
            title: 'Automatización',
            description: 'Sistemas integrados de control y monitoreo para plantas industriales, con interfaces HMI y registro completo de procesos.',
            imageKey: 'automatizacion',
            images: ['tecnal_aa_automatizacion_1.webp', 'tecnal_aa_automatizacion_2.webp', 'tecnal_aa_automatizacion_3.webp', 'tecnal_aa_automatizacion_4.webp', 'tecnal_aa_automatizacion_5.webp', 'tecnal_aa_automatizacion_6.webp'],
            href: '/tecnal/alimentacion-animal/automatizacion'
          }
        ]
      }
    ]
  },

  // Movimiento portuario page
  'movimiento-portuario': {
    slug: '/tecnal/movimiento-portuario',
    breadcrumb: 'Movimiento portuario',
    title: 'Movimiento portuario',
    intro: [
      'El Grupo TECNAL ofrece soluciones especializadas para operaciones portuarias de carga y descarga de granos.',
      'Equipos diseñados para maximizar la eficiencia en terminales portuarias, con alta capacidad de procesamiento y durabilidad.'
    ],
    sections: [
      {
        heading: 'Instalaciones de referencia',
        cards: [
          {
            title: 'Equipos para movimiento portuario',
            description: 'Sistemas de transporte y manejo de granos para terminales portuarias de alta capacidad.',
            imageKey: 'tecnal-mp-galeria',
            images: ['tecnal_mp_1.webp', 'tecnal_mp_2.webp', 'tecnal_mp_3.webp', 'tecnal_mp_4.webp', 'tecnal_mp_5.webp', 'tecnal_mp_6.webp', 'tecnal_mp_7.webp', 'tecnal_mp_8.webp', 'tecnal_mp_9.webp', 'tecnal_mp_10.webp', 'tecnal_mp_11.webp', 'tecnal_mp_12.webp', 'tecnal_mp_13.webp', 'tecnal_mp_14.webp', 'tecnal_mp_15.webp', 'tecnal_mp_16.webp', 'tecnal_mp_17.webp', 'tecnal_mp_18.webp', 'tecnal_mp_19.webp', 'tecnal_mp_20.webp', 'tecnal_mp_21.webp', 'tecnal_mp_22.webp', 'tecnal_mp_23.webp'],
            type: 'gallery'
          }
        ]
      }
    ]
  },

  // Etanol de maíz page
  'etanol-de-maiz': {
    slug: '/tecnal/etanol-de-maiz',
    breadcrumb: 'Etanol de maíz',
    title: 'Etanol de maíz',
    intro: [
      'TNL TECNAL se consolida como el socio tecnológico preferente de corporaciones líderes globales en el sector de biocombustibles.',
      'Actualmente es el proveedor principal de equipos para la planta de etanol de maíz más grande de Brasil, destacándose por su tecnología de vanguardia en secadores rotativos para el procesamiento de expeller de maíz, asegurando los más altos rendimientos industriales del mercado.'
    ],
    sections: [
      {
        heading: 'Instalaciones de referencia',
        cards: [
          {
            title: 'Planta de etanol de maíz',
            description: 'Equipos TECNAL para el procesamiento integral de maíz en plantas de bioetanol.',
            imageKey: 'tecnal-em-galeria',
            images: ['tecnal_em_1.webp', 'tecnal_em_2.webp', 'tecnal_em_3.webp', 'tecnal_em_4.webp', 'tecnal_em_5.webp', 'tecnal_em_6.webp', 'tecnal_em_7.webp', 'tecnal_em_8.webp'],
            type: 'gallery'
          }
        ]
      }
    ]
  },

  // Referencias pages
  'referencias-equipos-rotativos': {
    slug: '/tecnal/referencias/equipos-rotativos',
    breadcrumb: 'Equipos rotativos',
    title: 'Equipos rotativos',
    parentTitle: 'Principales referencias en el mundo',
    intro: [
      'Instalaciones en plantas industriales de Argentina, operando en procesos continuos de tratamiento y acondicionamiento de granos.'
    ],
    images: [
      'tecnal_rotativo_1.webp', 'tecnal_rotativo_2.webp', 'tecnal_rotativo_3.webp',
      'tecnal_rotativo_4.webp', 'tecnal_rotativo_5.webp', 'tecnal_rotativo_7.webp',
      'tecnal_rotativo_8.webp', 'tecnal_rotativo_9.webp', 'tecnal_rotativo_10.webp',
      'tecnal_rotativo_11.webp'
    ],
    category: 'referencias'
  },

  'referencias-expanders': {
    slug: '/tecnal/referencias/expanders',
    breadcrumb: 'Expanders',
    title: 'Expanders',
    parentTitle: 'Principales referencias en el mundo',
    intro: [
      'Referencias en operación en complejos de crushing y producción de balanceados a nivel nacional.'
    ],
    images: [
      'tecnal_expander_1.webp', 'tecnal_expander_2.webp', 'tecnal_expander_3.webp',
      'tecnal_expander_4.webp', 'tecnal_expander_5.webp', 'tecnal_expander_6.webp',
      'tecnal_expander_7.webp', 'tecnal_expander_8.webp', 'tecnal_expander_9.webp',
      'tecnal_expander_10.webp', 'tecnal_expander_11.webp', 'tecnal_expander_12.webp',
      'tecnal_expander_13.webp', 'tecnal_expander_14.webp', 'tecnal_expander_15.webp',
      'tecnal_expander_16.webp', 'tecnal_expander_17.webp', 'tecnal_expander_18.webp',
      'tecnal_expander_19.webp', 'tecnal_expander_20.webp'
    ],
    category: 'referencias'
  },

  'referencias-enfriadoras': {
    slug: '/tecnal/referencias/enfriadoras',
    breadcrumb: 'Enfriadoras de masa expandida',
    title: 'Enfriadoras de masa expandida',
    parentTitle: 'Principales referencias en el mundo',
    intro: [
      'Equipos instalados y funcionando en líneas industriales de procesamiento y estabilización de producto.'
    ],
    images: [
      'tecnal_secadora_1.webp', 'tecnal_secadora_2.webp', 'tecnal_secadora_3.webp',
      'tecnal_secadora_4.webp', 'tecnal_secadora_5.webp', 'tecnal_secadora_6.webp',
      'tecnal_secadora_7.webp', 'tecnal_secadora_8.webp', 'tecnal_secadora_9.webp',
      'tecnal_secadora_10.webp'
    ],
    category: 'referencias'
  }
};

// Equipment details for individual equipment pages
export const equipmentData = {
  // Almacenamiento de Granos equipment
  'almacenamiento-de-granos/prelimpieza': {
    slug: '/tecnal/almacenamiento-de-granos/prelimpieza',
    breadcrumb: 'Prelimpieza y limpieza',
    title: 'Prelimpieza y limpieza',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    description: 'Equipos para separar impurezas con succión regulable, autolimpieza y máxima seguridad operativa.',
    images: ['tecnal_ag_prelimpieza_3.webp', 'tecnal_ag_prelimpieza_1.webp', 'tecnal_ag_prelimpieza_2.webp', 'tecnal_ag_prelimpieza_4.webp', 'tecnal_ag_prelimpieza_5.webp'],
    technicalDescription: 'Las zarandas de prelimpieza y limpieza TECNAL poseen múltiples etapas de clasificación que separan el grano limpio de impurezas gruesas, vainas, corontas, cáscaras y polvo. El sistema de aspiración con regulación de caudal garantiza la extracción de polvo y cáscaras, mientras las esferas de goma aseguran la autolimpieza de las mallas. Los materiales indeseados se clasifican y descargan por separado, permitiendo su aprovechamiento en otras aplicaciones. Al final del proceso, el equipo clasifica el material en seis categorías distintas: granos limpios, quebrado, impurezas gruesas, vainas/corontas, impurezas livianas y polvo. Compatible con diferentes tipos de granos y semillas, cumple con la norma de seguridad NR-12.',
    technicalData: {
      intro: 'Con más de cuatro décadas de trayectoria, TNL TECNAL fabrica equipos de limpieza diseñados para las exigencias críticas de la agroindustria. El material procesado se clasifica en seis categorías finales: granos limpios, quebrado/granza, impurezas gruesas, vainas/corontas, impurezas livianas/cáscaras y polvo.',
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Sistema de aspiración con regulación micrométrica del flujo de aire para la extracción de finos',
            'Mallas de separación de impurezas gruesas que eliminan la necesidad de equipos previos adicionales',
            'Mecanismo de autolimpieza constante de mallas mediante esferas de goma',
            'Superficie de zarandeo dimensionada específicamente según el caudal de operación',
            'Diseño optimizado para facilitar el acceso a mallas, limpieza y mantenimiento preventivo',
            'Cumplimiento integral con la normativa de seguridad industrial NR-12',
            'Tolva de alimentación con dosificador rotativo para distribución homogénea (modelos 80–300 t/h)'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Garantía de calidad superior en el grano almacenado',
            'Minimización del riesgo de incendios en secaderos al eliminar polvo y partículas combustibles',
            'Reducción drástica de paradas no programadas para limpieza de equipos'
          ]
        }
      ]
    }
  },
  'almacenamiento-de-granos/secadora-vertical': {
    slug: '/tecnal/almacenamiento-de-granos/secadora-vertical',
    breadcrumb: 'Secadora vertical',
    title: 'Secadora vertical',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    pdfHref: '/assets/tecnal/pdfs/TECNAL_SECADORA.pdf',
    description: 'Para semilla de soja, maíz y girasol.',
    images: ['tecnal_ag_secadora-vertical_1.webp', 'tecnal_ag_secadora-vertical_2.webp', 'tecnal_ag_secadora-vertical_3.webp', 'tecnal_ag_secadora-vertical_4.webp'],
    technicalDescription: 'El secador vertical TECNAL está compuesto por dos cámaras de secado y una cámara de enfriamiento, con recirculación de aire caliente para ahorro de energía. Posee canal cónico patentado que promueve la ecualización y distribución del flujo de aire caliente y de granos en el interior del secador. El sistema de reutilización de aire caliente reduce considerablemente el consumo energético. Puede ser alimentado por horno de calor o por radiadores, y cuenta con dispositivos para monitoreo de temperatura y humedad en todas las cámaras, garantizando la calidad del grano secado. Su sistema modular totalmente atornillado facilita el transporte, montaje y la expansión de capacidad mediante la adición de módulos.',
    technicalData: {
      intro: 'Equipo modular constituido por cámaras de secado y enfriamiento configuradas para maximizar la eficiencia térmica. Incorpora un canal cónico patentado que asegura una distribución ecualizada del flujo de aire caliente y del grano, evitando zonas de sobrecalentamiento.',
      sections: [
        {
          title: 'Características',
          type: 'features',
          fullWidth: true,
          items: [
            'Construcción modular íntegramente atornillada para agilizar el transporte y montaje',
            'Escalabilidad de capacidad mediante la adición de módulos estándar',
            'Estructura fabricada en acero galvanizado de alta resistencia',
            'Ventiladores centrífugos compatibles con hornos de calor o radiadores',
            'Ductos de aire con aislamiento térmico para optimización del gradiente de temperatura',
            'Sistema de monitoreo en tiempo real con celdas de carga y sensores de temperatura y humedad'
          ]
        }
      ]
    }
  },
  'almacenamiento-de-granos/transportador-cinta-cerrado': {
    slug: '/tecnal/almacenamiento-de-granos/transportador-cinta-cerrado',
    breadcrumb: 'Transportador de cinta (cerrado)',
    title: 'Transportador de cinta (cerrado)',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    description: 'Transportador totalmente cerrado que evita dispersión de polvo, reduce ruido y mejora la limpieza del entorno operativo.',
    images: ['tecnal_ag_transportador-cerrado_2.webp', 'tecnal_ag_transportador-cerrado_1.webp', 'tecnal_ag_transportador-cerrado_3.webp', 'tecnal_ag_transportador-cerrado_4.webp', 'tecnal_ag_transportador-cerrado_5.webp', 'tecnal_ag_transportador-cerrado_6.webp', 'tecnal_ag_transportador-cerrado_7.webp', 'tecnal_ag_transportador-cerrado_8.webp'],
    technicalDescription: 'El transportador de correa encauzado TECNAL garantiza la máxima seguridad y protección de los productos transportados, reduciendo la generación de polvo y manteniendo la integridad del material. El equipo es totalmente cerrado, con correa de alta calidad con propiedades antiestáticas y retardantes de llama. Los rodillos de carga están diseñados especialmente con rodamientos tipo "pillow block", sello tipo "laberinto" y prensaestopas para retención de polvo. Los módulos están construidos en acero con paneles de acceso en UHMW y uniones bridadas, permitiendo la inspección y mantenimiento interno. El cabezal motriz incluye tambor emborrachado, balanceado y fijado por rodamientos, con accionamiento mediante reductores planetarios. Cumple con la norma de seguridad NR-12.',
    technicalData: {
      intro: 'Sistema diseñado para el transporte seguro de materiales con mínima generación de polvo. El equipo es totalmente estanco, protegiendo tanto la integridad del producto como el entorno operativo.',
      sections: [
        {
          title: 'Componentes Técnicos',
          type: 'components',
          fullWidth: true,
          items: [
            'Correa Laminada: construcción de 3 a 5 tejidos con cobertura de caucho antiestático y retardante de llama (Goodyear o Mercúrio); uniones por vulcanización en frío o empalmes mecánicos tipo Flexco o Huck',
            'Rodillos de Carga: rodamientos pillow block sellados y lubricados; engranaje bipartido y ventilación interna para disipación del calor por fricción',
            'Módulos: estructura de acero con paneles de acceso en UHMW y uniones bridadas para inspección técnica',
            'Cabezal Motriz: tambor emborrachado y balanceado sobre rodamientos SN-TG; accionamiento mediante reductores planetarios SEW o Sumitomo y motores WEG',
            'Cabezal Tensor: cuerpo telescópico de largo recorrido con sensores de atasco y tambor de retorno emborrachado'
          ]
        }
      ]
    }
  },
  'almacenamiento-de-granos/transportador-cadena': {
    slug: '/tecnal/almacenamiento-de-granos/transportador-cadena',
    breadcrumb: 'Transportador de cadena (tipo Redler)',
    title: 'Transportador de cadena (tipo Redler)',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    description: 'Transportador robusto, silencioso y de baja fricción, ideal para grandes capacidades y operación confiable.',
    images: ['tecnal_ag_transportador-redler_1.webp', 'tecnal_ag_transportador-redler_2.webp', 'tecnal_ag_transportador-redler_3.webp', 'tecnal_ag_transportador-redler_4.webp', 'tecnal_ag_transportador-redler_5.webp', 'tecnal_ag_transportador-redler_6.webp', 'tecnal_ag_transportador-redler_7.webp', 'tecnal_ag_transportador-redler_8.webp'],
    technicalDescription: 'El transportador de arrastre tipo Redler TECNAL, con capacidad de hasta 1000 t/h, está proyectado para atender las más variadas necesidades de transporte. Su robustez y bajo rozamiento garantizan una larga vida útil al equipo con bajo nivel de ruido. El cabezal motriz es robusto, con engranaje bipartido en acero al carbono y rodamientos autoalineantes. Los tramos están en chapas de acero dimensionadas para soportar el desgaste, con rieles de retorno en "V" para disminuir el rozamiento y eslabones en UHMW. Las tapas dobladas tipo techo evitan la acumulación de agua, fijadas con cierres rápidos galvanizados. Incluye ventanas de inspección con mallas de protección y visor de capa para visualización del producto en movimiento.',
    technicalData: {
      intro: 'Equipo de alta robustez para capacidades de hasta 1000 t/h. Su ingeniería de bajo rozamiento asegura una vida útil prolongada y niveles reducidos de ruido industrial.',
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Cabezal motriz y tensor con ranuras laterales para desmontaje rápido de ejes',
            'Engranajes bipartidos en acero al carbono o modular que permiten el reemplazo sin retirar el eje completo',
            'Rodamientos tipo SNH-TG con rodillos autoalineantes de alta carga',
            'Cadenas industriales de alta resistencia, destacando el estándar WHX',
            'Tramos con rieles de retorno en "V" y eslabones de arrastre en UHMW para reducir el desgaste',
            'Tapas superiores con diseño "tipo techo" para evitar la acumulación de fluidos, fijadas con cierres rápidos galvanizados'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Ventanas de inspección con mallas de seguridad y visores de capa para monitoreo de flujo',
            'Sensores de atasco y bocas de alivio con contrapeso integrados',
            'Protección integral de todas las partes móviles conforme a estándares internacionales'
          ]
        }
      ]
    }
  },
  'almacenamiento-de-granos/cinta-transportadora': {
    slug: '/tecnal/almacenamiento-de-granos/cinta-transportadora',
    breadcrumb: 'Cinta transportadora',
    title: 'Cinta transportadora',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    description: 'Cintas seguras y duraderas para el transporte continuo de granos, con estructuras reforzadas y opciones personalizadas.',
    images: ['tecnal_ag_cinta-transportadora_1.webp', 'tecnal_ag_cinta-transportadora_2.webp', 'tecnal_ag_cinta-transportadora_3.webp', 'tecnal_ag_cinta-transportadora_4.webp', 'tecnal_ag_cinta-transportadora_5.webp'],
    technicalDescription: 'Los transportadores de correa TECNAL son equipos robustos, seguros y de fácil operación, proyectados a medida para cada cliente. Garantizan la integridad de los productos durante todo el recorrido, para distancias cortas, medias o largas. Fabricados con estructuras galvanizadas, rodillos de alta durabilidad, tambores emborrachados y balanceados, con accionamiento mediante reductor de velocidad o poleas y correas. Disponibles con accesorios como tripper móvil manual o motorizado, tripper fijo o reversible, y tolvas de alimentación y bocas de descarga revestidas con UHMW o pastillas cerámicas.',
    technicalData: {
      intro: 'Solución versátil para el transporte horizontal o inclinado de soja, maíz y cereales diversos en cualquier distancia.',
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Estructura galvanizada autoportante',
            'Rodillos de alta durabilidad y cabezales reforzados',
            'Tambores emborrachados balanceados dinámicamente',
            'Rodamientos SN-bipartidos para agilizar las tareas de mantenimiento'
          ]
        },
        {
          title: 'Accesorios disponibles',
          type: 'accessories',
          items: [
            'Sistemas Tripper manual, motorizado o reversible',
            'Tensores de tornillo o gravitacionales (contrapeso) según la longitud',
            'Rodillo autolimpiante y revestimientos en UHMW o pastillas cerámicas'
          ]
        }
      ]
    }
  },
  'almacenamiento-de-granos/transporte-rosca': {
    slug: '/tecnal/almacenamiento-de-granos/transporte-rosca',
    breadcrumb: 'Transporte a rosca',
    title: 'Transporte a rosca',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    description: 'Equipo compacto y robusto para transporte de granos en distancias cortas y medias, con mantenimiento simple.',
    images: ['tecnal_ag_transporte-rosca_1.webp', 'tecnal_ag_transporte-rosca_2.webp', 'tecnal_ag_transporte-rosca_3.webp', 'tecnal_ag_transporte-rosca_4.webp', 'tecnal_ag_transporte-rosca_5.webp', 'tecnal_ag_transporte-rosca_6.webp'],
    technicalDescription: 'El sistema de roscas transportadoras TECNAL es ideal para el transporte de cereales a distancias cortas y medias. Sus dimensiones compactas permiten grandes capacidades ocupando poco espacio. Son equipos robustos con accionamiento por reductor de velocidad, secciones modulares y tapas fijadas por cierres rápidos. Las testeras cuentan con rodamientos autoalineantes para mayor durabilidad y facilidad de mantenimiento, garantizando operación continua y confiable.',
    technicalData: {
      intro: 'Ideal para la transferencia de cereales en espacios confinados y distancias cortas a medias.',
      sections: [
        {
          title: 'Características',
          type: 'features',
          fullWidth: true,
          items: [
            'Arquitectura modular compacta',
            'Tapas de inspección con cierres rápidos',
            'Testeras con rodamientos autoalineantes',
            'Accionamiento mediante reductor de velocidad de alto torque'
          ]
        }
      ]
    }
  },
  'almacenamiento-de-granos/elevador-noria': {
    slug: '/tecnal/almacenamiento-de-granos/elevador-noria',
    breadcrumb: 'Elevador / Noria',
    title: 'Elevador / Noria',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    description: 'Elevador vertical para granos con diseño modular, alta durabilidad y múltiples opciones de seguridad.',
    images: ['tecnal_ag_elevador_2.webp', 'tecnal_ag_elevador_1.webp', 'tecnal_ag_elevador_3.webp', 'tecnal_ag_elevador_4.webp', 'tecnal_ag_elevador_5.webp'],
    technicalDescription: 'Los elevadores centrífugos TECNAL atienden las más exigentes necesidades de transporte vertical de cereales, productos granulados o harinosos. El cabezal motriz aloja el accionamiento y la polea motriz que proyecta el producto hacia la boca de descarga; está equipado con respiradero, boca de visita, compuerta de atasco y bocas de explosión según modelo. El cabezal inferior se ofrece en versión convencional o autolimpiante, que mantiene distancia constante del cangilón al fondo para captación total del material. Los tramos incluyen opciones con rodillo guía, bocas de explosión, amortiguadores de llamas, ventanas de inspección y tramo de alimentación, adaptándose completamente a cada proyecto y disposición de montaje.',
    technicalData: {
      intro: 'Equipo especializado en el transporte vertical de productos granulados y harinosos, diseñado bajo los más estrictos estándares de calidad portuaria.',
      sections: [
        {
          title: 'Componentes Principales',
          type: 'components',
          fullWidth: true,
          items: [
            'Cabezal Motriz: gestiona la proyección centrífuga del producto desde los cangilones; equipado con compuerta de atasco, respiraderos de alivio y bocas de explosión',
            'Cabezal Inferior (Pie): disponible en versión autolimpiante donde todo el conjunto se desplaza para mantener la distancia constante entre el cangilón y el fondo, garantizando la captación total del producto',
            'Tramo con Rodillo Guía: instalado en pares cerca de los cabezales para evitar que la correa roce contra los laterales internos en caso de desalineación, previniendo el desgaste prematuro',
            'Tramo con Boca de Explosión: área de ruptura controlada con opción de amortiguador de llamas para instalaciones en pozos o espacios confinados',
            'Tramo de Inspección: equipado con visores transparentes para visualización operativa de los cangilones'
          ]
        }
      ]
    }
  },
  'almacenamiento-de-granos/cadenas': {
    slug: '/tecnal/almacenamiento-de-granos/cadenas',
    breadcrumb: 'Cadenas',
    title: 'Cadenas',
    category: 'almacenamiento-de-granos',
    categoryTitle: 'Almacenamiento de granos',
    description: 'Cadenas industriales de fabricación propia, con materiales certificados y alta durabilidad para equipos de transporte.',
    images: ['tecnal_ag_cadenas_1.webp', 'tecnal_ag_cadenas_2.webp', 'tecnal_ag_cadenas_3.webp', 'tecnal_ag_cadenas_4.webp', 'tecnal_ag_cadenas_5.webp', 'tecnal_ag_cadenas_6.webp', 'tecnal_ag_cadenas_7.webp'],
    technicalDescription: 'TECNAL fabrica cadenas industriales propias con un riguroso proceso de producción que asegura la más alta calidad. Toda la materia prima —acero al carbono, aleado o inoxidable— se verifica mediante espectrómetro y durómetro al momento de la recepción. Cada parte se produce con equipos CNC con corte por láser y estampado en prensa mecánica, y la producción se realiza mediante dispositivos hidráulicos y soldadura robotizada en estufa con temperatura controlada. El control de calidad incluye ensayos mecánicos, análisis metalúrgico, macrográfico, metalográfico e inspección por partículas magnéticas. Todos los equipos TECNAL de transporte —cadena, drag, Bulk Flow, secador y enfriador horizontal— utilizan cadenas de fabricación propia.',
    technicalData: {
      intro: 'TNL TECNAL fabrica sus propias cadenas para asegurar la integridad mecánica de sus redlers, secadores y enfriadores, consolidándose como proveedor incluso para otros fabricantes del sector.',
      sections: [
        {
          title: 'Proceso de Producción',
          type: 'process',
          fullWidth: true,
          items: [
            'Materia Prima: control por espectrómetro y durómetro de aceros certificados al momento de la recepción',
            'Preparación: mecanizado CNC de alta precisión, corte láser y estampado en prensa mecánica',
            'Producción: soldadura robotizada y procesos TIG/Tubular en ambientes de temperatura controlada',
            'Calidad: protocolo de ensayos mecánicos con análisis macrográfico y metalográfico, e inspección por partículas magnéticas',
            'Ingeniería: validación estructural mediante análisis de elementos finitos (FEA)'
          ]
        }
      ]
    }
  },

  // Aceite Vegetal equipment
  'aceite-vegetal/quebrador': {
    slug: '/tecnal/aceite-vegetal/quebrador',
    breadcrumb: 'Quebrador',
    title: 'Quebrador',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    pdfHref: '/assets/tecnal/pdfs/TECNAL_CRACKER-online.pdf',
    description: 'Molino preciso y seguro para triturar semillas oleaginosas sin contacto entre cilindros y con ajuste fino estable.',
    images: ['tecnal_av_quebrador_1.webp', 'tecnal_av_quebrador_2.webp', 'tecnal_av_quebrador_3.webp', 'tecnal_av_quebrador_4.webp'],
    technicalDescription: 'El quebrador TECNAL está diseñado para la rotura de granos oleaginosos con regulación de apertura entre rodillos y ajuste de velocidad. Su diferencial es el conjunto de rodillos flotantes con pistones hidráulicos para mayor eficiencia y seguridad, que permite un ajuste rápido de la holgura. El sistema de acoplamiento rápido facilita el cambio de rodillos y discos abrasivos sin desmontar el conjunto. Cuenta con panel de comando con rotación variable para ajuste del gap y sistema de freno para parada rápida de los rodillos, garantizando una granulometría uniforme y bajo consumo de energía.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Conjunto de rodillos flotantes con pistones hidráulicos para ajuste de precisión',
            'Sistema de acoplamiento rápido para intercambio de rodillos y discos abrasivos sin desmontaje total',
            'Panel de comando con regulación de velocidad y sistema de freno de parada rápida'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Estabilidad operativa superior y granulometría altamente uniforme',
            'Eficiencia energética optimizada y reducción de tiempos de mantenimiento'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/laminador': {
    slug: '/tecnal/aceite-vegetal/laminador',
    breadcrumb: 'Laminador',
    title: 'Laminador',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    pdfHref: '/assets/tecnal/pdfs/TECNAL_FLAKERS_online.pdf',
    description: 'Sistema de laminación de alta precisión con rodillos homogéneos, excelente disipación térmica y seguridad avanzada.',
    images: ['tecnal_av_laminador_1.webp', 'tecnal_av_laminador_2.webp', 'tecnal_av_laminador_3.webp', 'tecnal_av_laminador_4.webp', 'tecnal_av_laminador_5.webp', 'tecnal_av_laminador_6.webp', 'tecnal_av_laminador_7.webp', 'tecnal_av_laminador_8.webp'],
    technicalDescription: 'El laminador TECNAL está proyectado para laminar granos oleaginosos con capacidades de 200 a 500 TPD. Posee rodillos de alta precisión y uniformidad de temperatura, permitiendo arrastrar el material sin necesidad de rosca alimentadora. El accionamiento es con motor único y los pistones hidráulicos permiten un ajuste preciso de la laminación con sistema de seguridad con columnas. La carcasa robusta en hierro fundido con aislamiento acústico reduce ruidos y vibraciones. El sistema de ventilación y refrigeración mantiene la temperatura ideal de los rodillos, garantizando alta productividad en operación continua y mayor vida útil de los componentes.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Diseñado para capacidades de 200 a 500 TPD con rodillos de alta precisión',
            'Accionamiento mediante motor único',
            'Carcasa de hierro fundido con aislamiento acústico y sensores de metales integrados',
            'Pistones hidráulicos para el ajuste fino de la laminación'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Alta productividad en régimen continuo con mínima vibración y ruido',
            'Versatilidad para operar con o sin rosca alimentadora según la reología del grano'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/expander': {
    slug: '/tecnal/aceite-vegetal/expander',
    breadcrumb: 'Expander',
    title: 'Expander',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    pdfHref: '/assets/tecnal/pdfs/TECNAL_EXPANDER-online.pdf',
    description: 'Equipo de referencia mundial para expansión de masa oleaginosa, con operación continua y alta eficiencia energética.',
    images: ['tecnal_av_expander_1.webp', 'tecnal_av_expander_2.webp', 'tecnal_av_expander_3.webp', 'tecnal_av_expander_4.webp', 'tecnal_av_expander_5.webp', 'tecnal_av_expander_6.webp'],
    technicalDescription: 'Los expanders TECNAL están proyectados para aumentar la capacidad de extracción y mejorar la calidad del pellet de expeller para hasta 4000 TPD. Poseen tecnología propia con cuerpo en acero laminado y hélices especiales. El sistema de expansión está compuesto por cámara de compresión, cilindro con camisa de enfriamiento, camisa de compresión en acero cromo-níquel, émbolo cromado y camisa con extractor para extrusión. El equipo cuenta con alimentación por rosca modulada y control automático de la operación, resultando en mayor eficiencia en la extracción de aceite, reducción de costos operativos y mejor calidad del expeller.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Estructura robusta en acero laminado con hélices y émbolos cromados para máxima durabilidad',
            'Alimentación por rosca modulada con control automatizado',
            'Cámara de compresión con camisa de enfriamiento y extractor para extrusión'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Incremento crítico en la eficiencia de extracción de aceite',
            'Mejora sustancial en la calidad y densidad del expeller'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/columna-de-aire': {
    slug: '/tecnal/aceite-vegetal/columna-de-aire',
    breadcrumb: 'Columna de aire',
    title: 'Columna de aire',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Columna en cascada que mejora la separación de cáscaras y aumenta la pureza y calidad del producto.',
    images: ['tecnal_av_columna-aire_1.webp', 'tecnal_av_columna-aire_2.webp', 'tecnal_av_columna-aire_3.webp', 'tecnal_av_columna-aire_4.webp', 'tecnal_av_columna-aire_5.webp'],
    technicalDescription: 'La columna de aire TECNAL es un equipo de separación que utiliza flujos de aire para remover cáscaras e impurezas finas tras la rotura de semillas oleaginosas. Su principio aerodinámico maximiza la eficiencia de separación, aumentando el contenido de proteína en el expeller y mejorando la calidad general del producto. Es ideal para líneas de preparación de soja, girasol y otras oleaginosas.',
    technicalData: {
      intro: 'Separador aerodinámico diseñado para remover cáscaras y finos tras la rotura de semillas oleaginosas, incrementando el valor proteico del producto final.',
      sections: [
        {
          title: 'Ventajas',
          type: 'advantages',
          fullWidth: true,
          items: [
            'Remoción eficiente de cáscaras e impurezas livianas por principio aerodinámico',
            'Incremento del contenido de proteína en el expeller',
            'Mejora la calidad general del producto final'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/molino-map': {
    slug: '/tecnal/aceite-vegetal/molino-map',
    breadcrumb: 'Molino de martillos MAP',
    title: 'Molino de martillos MAP',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Molino de alta precisión para molienda fina, media o gruesa, con baja temperatura y cambio rápido de tamices.',
    images: ['tecnal_av_molino-martillo-map_1.webp', 'tecnal_av_molino-martillo-map_2.webp', 'tecnal_av_molino-martillo-map_3.webp', 'tecnal_av_molino-martillo-map_4.webp', 'tecnal_av_molino-martillo-map_5.webp', 'tecnal_av_molino-martillo-map_6.webp'],
    technicalDescription: 'El molino de martillos MAP TECNAL ofrece granulometría homogénea tanto para molienda gruesa, media o fina, con menor relación potencia instalada por tonelada producida (kW/t). El rotor con velocidad variable permite ajustes de caudal y granulometría. Opera con baja temperatura (< 45 °C) en la cámara de molienda, evitando la "quema" de almidones, vitaminas y proteínas. La alimentación uniforme protege contra la entrada de materiales ferrosos, y las mallas se sustituyen con el rotor en movimiento, reduciendo prácticamente a cero el tiempo de cambio. No requiere molinos adicionales para la primera molienda, independientemente de la granulometría deseada.',
    technicalData: {
      sections: [
        {
          title: 'Características Técnicas',
          type: 'features',
          items: [
            'Operación a baja temperatura (inferior a 45 °C) para evitar la degradación térmica de almidones y proteínas',
            'Sistema de cambio de mallas ultra rápido con el rotor en movimiento',
            'Rotor con velocidad variable para ajuste fino de granulometría'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Elimina la necesidad de una primera molienda, independientemente de la finura requerida',
            'Consumo energético reducido (baja relación kW/t)'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/molino-mmt': {
    slug: '/tecnal/aceite-vegetal/molino-mmt',
    breadcrumb: 'Molino de martillos MMT',
    title: 'Molino de martillos MMT',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Molino económico y robusto para molienda versátil, con bajo ruido y mantenimiento sencillo.',
    images: ['tecnal_av_molino-martillo-mmt_1.webp', 'tecnal_av_molino-martillo-mmt_2.webp', 'tecnal_av_molino-martillo-mmt_3.webp', 'tecnal_av_molino-martillo-mmt_4.webp', 'tecnal_av_molino-martillo-mmt_5.webp', 'tecnal_av_molino-martillo-mmt_6.webp', 'tecnal_av_molino-martillo-mmt_7.webp'],
    technicalDescription: 'El molino de martillos MMT TECNAL es un equipo robusto con características convencionales. Posee alimentador monobloque con rosca transportadora e imán para separación de metales. La velocidad periférica adecuada garantiza la granulometría requerida, y el rotor está soportado por rodamientos externos de fácil mantenimiento. El equipo incluye cabina acústica para reducción de ruido, caja de expansión para reducción de vibraciones y un sistema sencillo de instalación de mallas con rotación controlada.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Alimentador monobloque con imán permanente para protección contra metales',
            'Rotor soportado por rodamientos externos de fácil acceso',
            'Incluye cabina acústica y caja de expansión de serie'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Robustez mecánica para molienda convencional pesada',
            'Niveles de ruido y vibración controlados dentro de estándares industriales'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/acondicionador-rotativo': {
    slug: '/tecnal/aceite-vegetal/acondicionador-rotativo',
    breadcrumb: 'Acondicionador rotativo',
    title: 'Acondicionador rotativo',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Equipo térmico para preacondicionar semillas, con calentamiento uniforme y bajo consumo de vapor.',
    images: ['tecnal_av_rotativo_1.webp', 'tecnal_av_rotativo_2.webp', 'tecnal_av_rotativo_3.webp', 'tecnal_av_rotativo_4.webp', 'tecnal_av_rotativo_5.webp'],
    technicalDescription: 'El acondicionador rotativo TECNAL consiste en un tambor cilíndrico con tubos de calentamiento e inyección de vapor, utilizado en el acondicionamiento de semillas antes de la laminación. Garantiza humedad y temperatura ideales para el proceso con accionamiento por motor y reductor, y control automático de la entrada y salida de vapor. Su acondicionamiento homogéneo requiere baja potencia instalada y bajo consumo de vapor, facilitando la limpieza y el mantenimiento, y asegurando la calidad de la laminación posterior.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Tambor con tubos de calentamiento e inyección de vapor automatizada',
            'Accionamiento por motorreductor de alto rendimiento'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Acondicionamiento térmico homogéneo con baja potencia instalada',
            'Garantía de elasticidad óptima para el proceso de laminación posterior'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/extractor-rotativo': {
    slug: '/tecnal/aceite-vegetal/extractor-rotativo',
    breadcrumb: 'Extractor rotativo',
    title: 'Extractor rotativo',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    pdfHref: '/assets/tecnal/pdfs/TECNAL_Extrator-DT-online.pdf',
    description: 'Extractor de aceite de alta eficiencia, con celdas rotativas, control automático y bajo consumo energético.',
    images: ['tecnal_av_extractor-rotativo_1.webp', 'tecnal_av_extractor-rotativo_2.webp', 'tecnal_av_extractor-rotativo_3.webp', 'tecnal_av_extractor-rotativo_4.webp', 'tecnal_av_extractor-rotativo_5.webp'],
    technicalDescription: 'El extractor rotativo TECNAL es un extractor de solvente con celdas rotativas. Posee cuerpo fijo con rotor de baja velocidad que contiene celdas que reciben el expeller y permiten el lavado con solvente: el producto es drenado, lavado y drenado nuevamente hasta la extracción completa. Cuenta con automatización total del flujo de masa con control de rotación y nivel de solvente, tiempo de extracción ajustable, doble sistema de seguridad y medición de temperaturas de la miscela y del expeller.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Sistema de celdas rotativas con rotor de baja velocidad para lavado con solvente',
            'Automatización total del flujo de masa, niveles y rotación'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Extracción exhaustiva del aceite mediante ciclos optimizados de drenaje y lavado',
            'Seguridad operativa garantizada por doble sistema de monitoreo térmico'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/recuperacion-finos': {
    slug: '/tecnal/aceite-vegetal/recuperacion-finos',
    breadcrumb: 'Recuperación de finos',
    title: 'Recuperación de finos',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Criba rotativa cerrada que recupera partículas finas y reduce pérdidas, mejorando el rendimiento global.',
    images: ['tecnal_av_recuperacion-finos_1.webp', 'tecnal_av_recuperacion-finos_2.webp', 'tecnal_av_recuperacion-finos_3.webp', 'tecnal_av_recuperacion-finos_4.webp', 'tecnal_av_recuperacion-finos_5.webp'],
    technicalDescription: 'La recuperadora de finos TECNAL es una zaranda giratoria cerrada utilizada para la recuperación de finos en cáscaras, con rotación lenta para mayor eficiencia de zaranda. Las mallas son de rápida sustitución y el sistema de limpieza interna mediante esferas asegura operación continua sin interrupciones. El producto recuperado es derivado nuevamente al proceso, mejorando el rendimiento global de la planta y reduciendo pérdidas de material.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Zaranda giratoria cerrada de rotación lenta',
            'Mallas de sustitución rápida con esferas de limpieza interna'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Alta eficiencia en la recuperación de material valioso de las cáscaras',
            'Integración directa al flujo de proceso'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/desolventizador-tostador': {
    slug: '/tecnal/aceite-vegetal/desolventizador-tostador',
    breadcrumb: 'Desolventizador y tostador',
    title: 'Desolventizador y tostador',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Equipo diseñado para eliminar solventes y tratar térmicamente el salvado con alto control automático y eficiencia.',
    images: ['tecnal_av_tostador_1.webp', 'tecnal_av_tostador_2.webp', 'tecnal_av_tostador_3.webp', 'tecnal_av_tostador_4.webp', 'tecnal_av_tostador_5.webp', 'tecnal_av_tostador_6.webp', 'tecnal_av_tostador_7.webp', 'tecnal_av_tostador_8.webp'],
    technicalDescription: 'El desolventizador-tostador TECNAL, con capacidad de 600 TPD para soja laminada, combina la eliminación de solventes con el tratamiento térmico del expeller en un solo equipo. Está compuesto por recipientes en acero al carbono con revestimiento interno en acero inoxidable, inyección de vapor para calentamiento, eje central con cuchillas para mezclado y pre-desolventización del expeller. Incluye bomba de alimentación con control de caudal, sensores de temperatura y de nivel, y sistema de vacío para recuperación de solventes. La operación es totalmente automatizada mediante PLC, con bajo consumo de vapor y alta flexibilidad para diferentes materiales.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Equipo multietapas de gran capacidad (600 TPD)',
            'Vasos construidos en acero al carbono con revestimiento interno integral en acero inoxidable',
            'Eje central con cuchillas de mezcla y sistema de vacío para recuperación de solventes'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Bajo consumo de vapor gracias a la inyección controlada por PLC',
            'Alta resistencia a la corrosión y durabilidad estructural'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/molino-bellota': {
    slug: '/tecnal/aceite-vegetal/molino-bellota',
    breadcrumb: 'Molino de bellota',
    title: 'Molino de bellota',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Molino robusto que elimina bellotas del salvado, optimizando su calidad para secado y enfriamiento.',
    images: ['tecnal_av_molino-bellota_1.webp'],
    technicalDescription: 'El molino de bellota TECNAL elimina los gránulos del expeller mediante carcasa robusta, rotor con martillos y malla que rompen y separan los aglomerados. Optimiza la calidad del expeller para las etapas posteriores de secado y enfriamiento, permitiendo operación continua con mínimo mantenimiento.',
    technicalData: {
      intro: 'Equipo de impacto diseñado para la desintegración de gránulos en el expeller mediante un rotor de martillos y malla de clasificación.',
      sections: [
        {
          title: 'Ventajas',
          type: 'advantages',
          fullWidth: true,
          items: [
            'Desintegración eficiente de aglomerados en el expeller',
            'Optimiza la calidad del producto para las etapas posteriores de secado y enfriamiento',
            'Operación continua con mínimo mantenimiento'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/destileria': {
    slug: '/tecnal/aceite-vegetal/destileria',
    breadcrumb: 'Destilería',
    title: 'Destilería',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Sistema de destilación al vacío que reduce consumo energético y recupera solventes con máxima eficiencia.',
    images: ['tecnal_av_destileria_1.webp', 'tecnal_av_destileria_2.webp', 'tecnal_av_destileria_3.webp', 'tecnal_av_destileria_4.webp', 'tecnal_av_destileria_5.webp', 'tecnal_av_destileria_6.webp', 'tecnal_av_destileria_7.webp', 'tecnal_av_destileria_8.webp'],
    technicalDescription: 'La destilería TECNAL elimina el solvente de la miscela mediante un sistema de evaporación con múltiples efectos, columna de vacío, regeneradores de energía y condensadores. Esta tecnología de múltiples efectos proporciona importante ahorro de vapor y reciclado de calor, garantizando una miscela constante y eficiente. Minimiza pérdidas de solvente con operación completamente automatizada para proceso continuo.',
    technicalData: {
      intro: 'Sistema de evaporación de múltiples efectos diseñado para la remoción eficiente de solventes, incorporando regeneradores de energía para el reciclado de calor.',
      sections: [
        {
          title: 'Ventajas',
          type: 'advantages',
          fullWidth: true,
          items: [
            'Importante ahorro de vapor mediante tecnología de múltiples efectos',
            'Reciclado de calor mediante regeneradores de energía',
            'Miscela constante y eficiente con mínimas pérdidas de solvente',
            'Operación completamente automatizada para proceso continuo'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/secadora-enfriadora': {
    slug: '/tecnal/aceite-vegetal/secadora-enfriadora',
    breadcrumb: 'Secadora / Enfriadora',
    title: 'Secadora / Enfriadora',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Equipo automatizado para secado y enfriamiento homogéneo de masa expandida o salvado, con alta eficiencia térmica.',
    images: ['tecnal_av_secadora-enfriador_1.webp', 'tecnal_av_secadora-enfriador_2.webp', 'tecnal_av_secadora-enfriador_3.webp', 'tecnal_av_secadora-enfriador_4.webp', 'tecnal_av_secadora-enfriador_5.webp', 'tecnal_av_secadora-enfriador_6.webp'],
    technicalDescription: 'El equipo secadora/enfriadora TECNAL fue desarrollado para secar y enfriar meal expandido o expeller. Compuesto por cuerpo en acero con carcasa aislada, alimentación con control de nivel y accionamiento por motorreductor. El control automático de la velocidad de la cadena mediante transmisor de nivel garantiza la uniformidad del proceso. Disponible en construcción vertical u horizontal, con cámaras de secado y enfriamiento separadas, control de humedad y temperatura, logrando reducción significativa del consumo de energía y facilidad de limpieza y mantenimiento.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Configuraciones vertical u horizontal con cámaras segregadas',
            'Dispositivo de alimentación patentado para asegurar una capa uniforme',
            'Control automático de velocidad de cadena mediante transmisores de nivel'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Optimización del contenido de humedad final y temperatura para almacenamiento',
            'Reducción significativa de los costos operativos por ahorro de energía'
          ]
        }
      ]
    }
  },
  'aceite-vegetal/secadora-acondicionador': {
    slug: '/tecnal/aceite-vegetal/secadora-acondicionador',
    breadcrumb: 'Secadora / Acondicionador',
    title: 'Secadora / Acondicionador',
    category: 'aceite-vegetal',
    categoryTitle: 'Aceite vegetal',
    description: 'Equipo vertical que acondiciona y seca semillas enteras, mejorando su rotura, separación y rendimiento de extracción.',
    images: ['tecnal_av_secadora-acondicionador_1.webp', 'tecnal_av_secadora-acondicionador_2.webp', 'tecnal_av_secadora-acondicionador_3.webp', 'tecnal_av_secadora-acondicionador_4.webp', 'tecnal_av_secadora-acondicionador_5.webp', 'tecnal_av_secadora-acondicionador_6.webp'],
    technicalDescription: 'El secador/acondicionador vertical TECNAL calienta semillas de soja a aproximadamente 75 °C mientras reduce la humedad del grano. Combina las funciones de secado y acondicionamiento en un único equipo, permitiendo mayor eficiencia del proceso y preparando las semillas de manera óptima para las etapas de quebrado y laminado, mejorando su rotura, separación de cáscara y rendimiento de extracción de aceite.',
    technicalData: {
      intro: 'Equipo vertical de alta eficiencia que integra el calentamiento de semillas (75 °C) y la deshidratación en una sola operación continua.',
      sections: [
        {
          title: 'Ventajas',
          type: 'advantages',
          fullWidth: true,
          items: [
            'Integra secado y acondicionamiento en un único equipo',
            'Prepara las semillas de manera óptima para las etapas de quebrado y laminado',
            'Mejora la rotura, separación de cáscaras y rendimiento de extracción de aceite'
          ]
        }
      ]
    }
  },

  // Alimento balanceado equipment
  'alimentacion-animal/extrusora-eap': {
    slug: '/tecnal/alimentacion-animal/extrusora-eap',
    breadcrumb: 'Extrusora EAP',
    title: 'Extrusora EAP',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Modelo robusto para la preparación y expansión de granos oleaginosos, ideal para líneas de extracción de aceite.',
    images: ['tecnal_aa_extrusora-eap_1.webp', 'tecnal_aa_extrusora-eap_2.webp', 'tecnal_aa_extrusora-eap_3.webp'],
    technicalDescription: 'La extrusora EAP TECNAL posee cuerpo modular en chapa de acero montada atornillada, con hélices de alta resistencia y acabado cromado, cámara de compresión y matriz de extrusión. Las cámaras de compresión, hélices y matrices están refrigeradas, permitiendo mayor productividad. Utiliza un exclusivo sistema MAP para mejor homogeneización, con diseño robusto de fácil mantenimiento y sistema de corte y matriz innovadores. La operación continua garantiza alta productividad, durabilidad, mejora en la consistencia y textura del producto final, con posibilidad de extrusión de diferentes recetas.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Cuerpo modular atornillado y sistema MAP de homogeneización',
            'Componentes críticos (hélices y matrices) con acabado cromado y refrigeración'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Consistencia superior en textura y palatabilidad',
            'Mantenimiento simplificado mediante asistencia por monorriel'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/enfriador-vertical': {
    slug: '/tecnal/alimentacion-animal/enfriador-vertical',
    breadcrumb: 'Enfriador vertical',
    title: 'Enfriador vertical',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Diseño contracorriente para enfriamiento gradual de producto granulado o extruido, asegurando estabilidad térmica y calidad final.',
    images: ['tecnal_aa_enfriador-vertical_1.webp', 'tecnal_aa_enfriador-vertical_2.webp', 'tecnal_aa_enfriador-vertical_3.webp'],
    technicalDescription: 'El enfriador vertical TECNAL está proyectado para enfriar alimento balanceado peletizado o extrusado. Posee distribuidor y esparcidor para uniformizar la distribución del producto, cuerpo cilíndrico con sistema contracorriente de aire y descarga inferior con sistema de palanca. El ventilador está dimensionado para alta eficiencia de enfriamiento, logrando mejor uniformidad de enfriamiento, reducción de costos de mantenimiento, posibilidad de ajuste del tiempo de enfriamiento y diseño compacto.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Diseño cilíndrico con sistema de flujo de aire contracorriente',
            'Distribuidor y esparcidor de alta eficiencia'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Enfriamiento uniforme con un requerimiento de espacio reducido'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/acondicionador-horizontal': {
    slug: '/tecnal/alimentacion-animal/acondicionador-horizontal',
    breadcrumb: 'Acondicionador horizontal',
    title: 'Acondicionador horizontal',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Unidad para control de humedad y temperatura antes de la extrusión o prensado, asegurando condiciones óptimas de proceso.',
    images: ['tecnal_aa_acondicionador-horizontal_1.webp'],
    technicalDescription: 'El acondicionador horizontal TECNAL está constituido por dos ejes horizontales con hélices que trabajan en rotación contraria para mejor homogeneización y cocción del alimento. Construido totalmente en acero inoxidable con opción de revestimiento aislante, posee diversas entradas de vapor e inyección de líquidos, ejes con hélices de paso variable y sonda de temperatura para control del producto. Garantiza acondicionamiento uniforme del alimento, mejora la digestibilidad y conversión alimentaria, control preciso del tiempo de residencia y bajo consumo de vapor.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Ejes contrarrotatorios fabricados íntegramente en acero inoxidable',
            'Sondas de temperatura para control de proceso'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Cocción uniforme y mejora en la digestibilidad con bajo consumo de vapor'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/expander': {
    slug: '/tecnal/alimentacion-animal/expander',
    breadcrumb: 'Expander',
    title: 'Expander',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Equipos de alta capacidad para preparación y expansión de oleaginosas, mejorando la eficiencia de extracción y el valor proteico del producto.',
    images: ['tecnal_aa_expander_1.webp'],
    technicalDescription: 'Los expanders TECNAL para alimento balanceado mejoran la gelatinización del almidón, aumentando la conversión alimentaria y proporcionando pellets con mayor durabilidad. Son especialmente recomendados para alimentos de cerdos, aves y peces, ya que reducen la incidencia de úlcera gástrica y eliminan Salmonella. Aumentan la capacidad de extrusión, permiten el uso de ingredientes alternativos y materias primas con mayor humedad, reducen el desgaste de las matrices del peletizador y aumentan la rentabilidad del proceso.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Optimización de la gelatinización del almidón mediante alta presión y cizallamiento',
            'Eliminación biológica de Salmonella'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Mejora drástica en la conversión alimentaria',
            'Reducción de patologías gástricas en animales'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/extrusora-edr': {
    slug: '/tecnal/alimentacion-animal/extrusora-edr',
    breadcrumb: 'Extrusora EDR',
    title: 'Extrusora EDR',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Equipo de extrusión de alta eficiencia para la cocción y desactivación de harinas y subproductos oleaginosos.',
    images: ['tecnal_aa_extrusora-edr_2.webp', 'tecnal_aa_extrusora-edr_1.webp', 'tecnal_aa_extrusora-edr_3.webp', 'tecnal_aa_extrusora-edr_4.webp', 'tecnal_aa_extrusora-edr_5.webp', 'tecnal_aa_extrusora-edr_6.webp'],
    technicalDescription: 'La extrusora EDR TECNAL está desarrollada para producción de alimento balanceado y extrusión de cereales, con cuerpo robusto en acero y hélices especialmente diseñadas y refrigeradas por agua. El acoplamiento por brida y eje estriado ofrece protección en todos los puntos de peligro, y el calentamiento controlado permite rápida estabilización de la temperatura. Las hélices están construidas en acero SAE 8620 templado y la camisa de extrusión es segmentada con tratamiento térmico. El sistema de corte tiene cuchillas ajustables. Evita la quema de grasas en el alimento, posibilita trabajar con matrices de mayor tamaño y puede extrudir diferentes tipos de materia prima con operación automatizada.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Hélices en acero SAE 8620 templado refrigeradas por agua',
            'Acoplamiento por brida y eje estriado con protección integral',
            'Camisa de extrusión segmentada con tratamiento térmico'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Prevención absoluta de la quema de grasas',
            'Estabilización térmica ultra rápida para procesos delicados'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/mezclador-mdp': {
    slug: '/tecnal/alimentacion-animal/mezclador-mdp',
    breadcrumb: 'Mezclador MDP',
    title: 'Mezclador MDP',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Equipo horizontal de paletas para mezcla homogénea de ingredientes secos o húmedos en procesos industriales.',
    images: ['tecnal_aa_mezclador-mdp_2.webp', 'tecnal_aa_mezclador-mdp_1.webp', 'tecnal_aa_mezclador-mdp_3.webp', 'tecnal_aa_mezclador-mdp_4.webp', 'tecnal_aa_mezclador-mdp_5.webp'],
    technicalDescription: 'El mezclador MDP TECNAL es un mezclador de doble eje con paletas (paddle) que opera en batches, permitiendo mezclas rápidas y homogéneas de ingredientes secos y líquidos. La cámara de mezcla no tiene puntos muertos ni tornillos, garantizando higiene. Posee opción de recobrimiento al vacío para adición de aceites, grasas y aromas, con sistema de paletas ajustables y tapa total para inspección y limpieza. El control automático de tiempos de mezcla y descarga permite registros de producción y trazabilidad, con posibilidad de uso de sistema de vacío para mejor impregnación de líquidos.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Doble eje con paletas (paddle) en cámara sin puntos muertos',
            'Construcción opcional en acero inoxidable y sistema de vacío para recobrimiento profundo'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Homogeneidad total en tiempos mínimos de ciclo',
            'Higiene garantizada para cumplimiento de normativas de nutrición animal'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/molino-map': {
    slug: '/tecnal/alimentacion-animal/molino-map',
    breadcrumb: 'Molino de martillos MAP',
    title: 'Molino de martillos MAP',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Modelo diseñado para molienda continua de productos granulados, garantizando tamaño uniforme y alta durabilidad.',
    images: ['tecnal_aa_molino-martillo-map_3.webp', 'tecnal_aa_molino-martillo-map_1.webp', 'tecnal_aa_molino-martillo-map_2.webp', 'tecnal_aa_molino-martillo-map_4.webp', 'tecnal_aa_molino-martillo-map_5.webp', 'tecnal_aa_molino-martillo-map_6.webp'],
    technicalDescription: 'El molino de martillos MAP TECNAL para alimento balanceado ofrece granulometría homogénea tanto para molienda gruesa, media o fina, con menor relación potencia instalada por tonelada producida (kW/t). El rotor con velocidad variable permite ajustes de caudal y granulometría, operando con baja temperatura en la cámara de molienda. La alimentación uniforme protege contra la entrada de materiales ferrosos, y las mallas se sustituyen con el rotor en movimiento, reduciendo prácticamente a cero el tiempo de cambio.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Alimentador con separador magnético y generador de vacío para control de finos',
            'Rotor con velocidad variable para ajuste fino de granulometría',
            'Sistema de cambio de mallas ultra rápido con el rotor en movimiento'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Alta eficiencia de molienda con niveles mínimos de ruido',
            'Operación a baja temperatura para preservar nutrientes'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/molino-mmt': {
    slug: '/tecnal/alimentacion-animal/molino-mmt',
    breadcrumb: 'Molino de martillos MMT',
    title: 'Molino de martillos MMT',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Versión reforzada para molienda intensiva con fácil mantenimiento y eficiencia energética optimizada.',
    images: ['tecnal_aa_molino-martillo-mmt_4.webp', 'tecnal_aa_molino-martillo-mmt_1.webp', 'tecnal_aa_molino-martillo-mmt_2.webp', 'tecnal_aa_molino-martillo-mmt_3.webp', 'tecnal_aa_molino-martillo-mmt_5.webp', 'tecnal_aa_molino-martillo-mmt_6.webp', 'tecnal_aa_molino-martillo-mmt_7.webp'],
    technicalDescription: 'El molino de martillos MMT TECNAL para alimento balanceado utiliza alimentador monobloque con separador magnético para impedir la entrada de metales. Posee velocidad periférica adecuada para uniformidad de partícula y generador de vacío para reducción de polvo. El rotor está montado sobre rodamientos externos de fácil mantenimiento y posee caja de expansión para reducir vibraciones, garantizando bajo nivel de ruido, mantenimiento simplificado y alta eficiencia de molienda.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Alimentador con separador magnético y generador de vacío para control de finos',
            'Rotor montado sobre rodamientos externos de fácil acceso'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Alta eficiencia de molienda con niveles mínimos de ruido'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/mezclador-horizontal': {
    slug: '/tecnal/alimentacion-animal/mezclador-horizontal',
    breadcrumb: 'Mezclador horizontal',
    title: 'Mezclador horizontal',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Sistema con eje doble o simple para mezcla uniforme de polvos, harinas o premezclas, con tiempos de ciclo reducidos.',
    images: ['tecnal_aa_mezclador-horizontal_1.webp', 'tecnal_aa_mezclador-horizontal_2.webp'],
    technicalDescription: 'El mezclador horizontal TECNAL es un equipo robusto para mezcla homogénea de ingredientes en alimento balanceado. Posee eje con hélices dobles de paso variable que proporciona mayor eficiencia de mezcla, con el eje apoyado externamente para un sellado adecuado. La tapa con apertura total facilita la limpieza e inspección, y el descompresor elimina el aire en los rodamientos. Ofrece mezcla homogénea de ingredientes, facilidad de limpieza, posibilidad de agregar líquidos durante la mezcla y bajo mantenimiento.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Eje con hélices dobles de paso variable y descompresor para rodamientos',
            'Apertura total de tapas para saneamiento'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Mezcla perfecta de ingredientes incluso con adición de líquidos'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/secadora-horizontal': {
    slug: '/tecnal/alimentacion-animal/secadora-horizontal',
    breadcrumb: 'Secadora horizontal',
    title: 'Secadora horizontal',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Equipo para reducción de humedad mediante flujo de aire caliente controlado, garantizando uniformidad de secado.',
    images: ['tecnal_aa_secadora-horizontal_1.webp', 'tecnal_aa_secadora-horizontal_2.webp'],
    technicalDescription: 'La secadora horizontal TECNAL, con sistema de alimentación patentado, seca el alimento balanceado extrusado mediante carcasa en acero al carbono, cinta transportadora y cámaras de secado con control de temperatura. Su construcción modular permite diversas capacidades, con paneles aislados térmicamente y control automático de temperatura y velocidad. El sistema patentado de alimentación evita daños al pellet, y los filtros y ciclones remueven el polvo, garantizando alta eficiencia de secado y adaptabilidad a variadas formulaciones.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Arquitectura modular con paneles aislados y sistema de alimentación patentado',
            'Control automatizado de velocidad y temperatura'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Alta eficiencia térmica preservando la integridad física del pellet'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/premezcladora': {
    slug: '/tecnal/alimentacion-animal/premezcladora',
    breadcrumb: 'Premezcladora',
    title: 'Premezcladora',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Sistema diseñado para mezclar líquidos y sólidos en proporciones exactas antes de la extrusión o peletizado.',
    images: ['tecnal_aa_premezcladora_1.webp'],
    technicalDescription: 'El sistema de premezcladora TECNAL está diseñado para el pesaje y mezcla en la producción de premixes vitamínicos. Posee silos de almacenamiento, balanzas de alta precisión, roscas transportadoras y granuladores, todos construidos en acero inoxidable para evitar contaminación. El sistema es completamente automático sin necesidad de intervención manual, garantizando precisión en el pesaje y en la mezcla, reducción de contaminaciones y versatilidad para diferentes recetas.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Silos y balanzas de pesaje de alta fidelidad en acero inoxidable',
            'Transporte neumático o por roscas sanitarias'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Eliminación de la intervención manual',
            'Prevención de contaminación cruzada'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/extrusora-exa': {
    slug: '/tecnal/alimentacion-animal/extrusora-exa',
    breadcrumb: 'Extrusora EXA',
    title: 'Extrusora EXA',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Equipo de extrusión de gran porte para procesamiento continuo, con control preciso de temperatura y presión.',
    images: ['tecnal_aa_extrusora-exa_1.webp'],
    technicalDescription: 'La extrusora EXA TECNAL está proyectada para producción de snacks y alimentos extrusados, con posibilidad de extrusión bicolor. Posee construcción robusta y de alta durabilidad, con cámara de compresión y matriz en acero cromado, cabezal en acero fundido con matriz de alta precisión y hélice con revestimiento de alta resistencia. El sistema de alimentación es ajustable, con facilidad de mantenimiento, mayor flexibilidad de formulaciones, elevada durabilidad de los componentes y diseño orientado a la seguridad y operación.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Cabezal de acero fundido y matriz de alta precisión',
            'Configuración disponible para extrusión bicolor (snacks)'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Flexibilidad total para formulaciones complejas',
            'Alta durabilidad mecánica'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/recubridor-continuo': {
    slug: '/tecnal/alimentacion-animal/recubridor-continuo',
    breadcrumb: 'Recubridor continuo',
    title: 'Recubridor continuo',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Equipo para aplicación uniforme de aceites, grasas o aditivos sobre el producto final, con control de caudal y temperatura.',
    images: ['tecnal_aa_recubridor-continuo_1.webp'],
    technicalDescription: 'El recubridor continuo TECNAL aplica aceites, grasas y aditivos de forma uniforme sobre el producto extruido o peletizado, mejorando su palatabilidad y valor nutricional.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Tambor giratorio de acero inoxidable con sistema de aspersión regulable',
            'Automatización de flujo y velocidad de rotación'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Recubrimiento homogéneo',
            'Reducción de mermas de ingredientes líquidos'
          ]
        }
      ]
    }
  },
  'alimentacion-animal/automatizacion': {
    slug: '/tecnal/alimentacion-animal/automatizacion',
    breadcrumb: 'Automatización',
    title: 'Automatización',
    category: 'alimentacion-animal',
    categoryTitle: 'Alimento balanceado',
    description: 'Sistemas integrados de control y monitoreo para plantas industriales, con interfaces HMI y registro completo de procesos.',
    images: ['tecnal_aa_automatizacion_1.webp', 'tecnal_aa_automatizacion_2.webp', 'tecnal_aa_automatizacion_3.webp', 'tecnal_aa_automatizacion_4.webp', 'tecnal_aa_automatizacion_5.webp', 'tecnal_aa_automatizacion_6.webp'],
    technicalDescription: 'Los sistemas de automatización TECNAL integran todos los equipos de la planta en una plataforma de control unificada. Interfaces HMI intuitivas permiten monitoreo y ajuste en tiempo real, mientras el sistema de registro documenta todos los parámetros de proceso para trazabilidad y optimización.',
    technicalData: {
      sections: [
        {
          title: 'Características',
          type: 'features',
          items: [
            'Interfaz mediante pantallas touch screen e integración total con ERP (SAP, TOTVS)',
            'Algoritmos de pesaje de alta precisión y reportes de trazabilidad'
          ]
        },
        {
          title: 'Ventajas',
          type: 'advantages',
          items: [
            'Eliminación de errores humanos y cumplimiento estricto de la norma NR-12',
            'Optimización del inventario y control de stocks en tiempo real'
          ]
        }
      ]
    }
  }
};

export default tecnalData;
